import { render, staticRenderFns } from "./tableTeacher.vue?vue&type=template&id=ba6fcbb0&"
import script from "./tableTeacher.js?vue&type=script&lang=js&"
export * from "./tableTeacher.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports